import { useTrackEvent } from '@olxeu-a2b/delivery-utils/src/tracking/useNinja';
import React, { useState } from 'react';
import trackingKeys from '../../../../commons/constants/trackingKeys';
import InfoButton from '../../../../commons/components/InfoButton';
import InfoModal from '../../../../commons/components/InfoModal';
import { USER_TYPE } from '../../constants';
import { useI18n } from '../../../../i18n';

interface ReturnsInfoProps {
  isDesktop: boolean;
  isSeller: boolean;
  touchPointPage: string;
  adId: string | number;
  sellerId: string;
}

const getTranslations = (i18n: any) => ({
  seller: {
    descriptionTextKeys: {
      main: 'dlv_returns_modal_description_seller',
    },
    contentTextKeys: [
      {
        tickHeader: 'dlv_returns_modal_tick_1_header_seller',
        tickDescription: 'dlv_returns_modal_tick_1_description_seller',
      },
      {
        tickHeader: 'dlv_returns_modal_tick_2_header_seller',
        tickDescription: 'dlv_returns_modal_tick_2_description_seller',
      },
      {
        tickHeader: 'dlv_returns_modal_tick_3_header_seller',
        tickDescription: '',
        specificTickDescription: (
          <>
            <span>{i18n('dlv_returns_modal_tick_3_description_seller_1')}</span>
            <br />
            <span>
              <strong>{i18n('dlv_returns_modal_tick_3_description_seller_2')}</strong>{' '}
              {i18n('dlv_returns_modal_tick_3_description_seller_3')}
            </span>
          </>
        ),
      },
    ],
    readMore: 'dlv_returns_modal_read_more_about_returns',
  },
  buyer: {
    descriptionTextKeys: {
      main: 'dlv_returns_modal_description',
    },
    contentTextKeys: [
      {
        tickHeader: 'dlv_returns_modal_tick_1_header',
        tickDescription: 'dlv_returns_modal_tick_1_description',
      },
      {
        tickHeader: 'dlv_returns_modal_tick_2_header',
        tickDescription: 'dlv_returns_modal_tick_2_description',
      },
      {
        tickHeader: 'dlv_returns_modal_tick_3_header',
        tickDescription: 'dlv_returns_modal_tick_3_description',
      },
    ],
    readMore: 'dlv_returns_modal_read_more_about_returns',
  },
});

const { howReturnsWork } = trackingKeys.events.safeDeal;

const ReturnsInfo: React.FC<ReturnsInfoProps> = ({
  isDesktop,
  isSeller,
  touchPointPage,
  adId,
  sellerId,
}) => {
  const i18n = useI18n();
  const trackEvent = useTrackEvent();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const trackingExtras = {
    seller_type: isSeller ? USER_TYPE.SELLER : USER_TYPE.BUYER,
    ad_id: adId,
    seller_id: sellerId,
    touch_point_page: touchPointPage,
  };

  const onOpenModalBtnClickHandler = () => {
    trackEvent(howReturnsWork, null, null, trackingExtras);
    setIsModalVisible(true);
  };

  const handleModalToggle = (toggle: boolean) => setIsModalVisible(toggle);
  const translationsVersion = isSeller ? getTranslations(i18n).seller : getTranslations(i18n).buyer;

  return (
    <>
      <InfoButton infoTrigger={onOpenModalBtnClickHandler} btnTextKey="dlv_returns_info_button" />
      {isModalVisible && (
        <InfoModal
          handleModalToggle={handleModalToggle}
          isDesktop={isDesktop}
          headerTextKey="dlv_returns_modal_title"
          descriptionTextKeys={{
            main: translationsVersion.descriptionTextKeys.main,
          }}
          contentTextKeys={translationsVersion.contentTextKeys}
          readMore={translationsVersion.readMore}
          trackingExtras={trackingExtras}
          closeModalTrackingKey={trackingKeys.events.safeDeal.closeModalReturnsBtn}
        />
      )}
    </>
  );
};

export default ReturnsInfo;
